export default function (element, data) {
    const girl = element.querySelector(".girl"); // Блок девушки
    const clouds = element.querySelectorAll(".cloud"); // Блоки облаков
    const interval = data.interval; // Интервал анимации
    const plant = element.querySelector(".plant"); // Блок 1
    const laptop = element.querySelector(".laptop"); // Блок 2
    let counter = 1;

    const mobileText = element.querySelector(".mobile-text");
    const texts = mobileText.querySelectorAll(".text");


    const isMobile = window.matchMedia("only screen and (max-width: 960px)").matches;
    const isiPhone = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

    //start(); // Запуск

    window.addEventListener("slidefirststart", start); // Слушатель события
    window.addEventListener("slidefirstreset", reset); // Слушатель события

    function start() {
        if(element.classList.contains("active")) {
            clouds[0].classList.add("show");
            window.dispatchEvent(new CustomEvent("mobiletextupdate", {detail: {text: texts[0].innerText}}));

            plant.classList.add("active");
            laptop.classList.add("active");

            plant.style.animationDelay = interval + "ms";
            laptop.style.animationDelay = interval + "ms";

            setTimeout(update, interval);
        }
    }

    function update() {
        if(counter <= 3 && element.classList.contains("active")) {
            girl.classList.add("animation-"+counter);

            if(clouds[counter]) {
                window.dispatchEvent(new CustomEvent("mobiletextupdate", {detail: {text: texts[counter].innerText}}));
                clouds[counter].classList.add("show");
                if(counter > 0) {
                    clouds[counter-1].classList.add("hide");
                    clouds[counter-1].classList.remove("show");
                }
                if(counter > 1) {
                    clouds[counter-2].classList.remove("hide");
                }
            } else {
                //window.dispatchEvent(new CustomEvent("mobiletextupdate", {detail: {text: ""}}));
                clouds[clouds.length - 1].classList.add("hide");
                clouds[clouds.length - 1].classList.remove("show");
            }

            counter++;

            if ((isMobile || isiPhone()) && counter == 3) {
                setTimeout(update, interval / 2);
            } else {
                setTimeout(update, interval);
            }
        } else {
            //reset();
        }
    }

    // Сброс анимации
    function reset() {
        girl.className = "girl";
        counter = 1;

        // Перезагрузка анимации растения и ноутбука
        plant.style.animation = 'none';
        laptop.style.animation = 'none';
        setTimeout(function() {
            // Перезагрузка анимации растения и ноутбука
            plant.style.animation = '';
            laptop.style.animation = '';
            plant.style.animationDelay = interval + "ms";
            laptop.style.animationDelay = interval + "ms";

            clouds.forEach(cloud => {
                cloud.classList.remove("hide");
            });

            clouds[0].classList.add("show");
        }, 50); // Таймаут для корректного сброса анимации с растения и ноутбука
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
